import { createContext } from 'react';

const PageHeaderContext = createContext({
  pageHeader: null,
  setPageHeader: () => {}
});

export default PageHeaderContext;
